import { Gruser } from '../types/papi';
import { useContext } from 'react';
import GruserContext from '../context/GruserContext/GruserContext';
import { generateGruserObjectId } from '../redux/helpers';
import { PapiUser } from '@wix/da-papi-types';

export const useGruser = (): {
  gruser: Gruser | undefined;
  gruserOwner: PapiUser | undefined;
} => {
  return useContext(GruserContext);
};

export const useGruserObjectId = (): string | undefined => {
  const { gruser } = useGruser();
  return gruser && generateGruserObjectId(gruser);
};

export default useGruser;
